import { useNavigate, useSearchParams } from 'react-router-dom'
import { notifications } from '@mantine/notifications'
import EmpresaForm from './EmpresaForm'
import {
  useEmpresaCreate,
  type EmpresaFormData,
  type PapelEmpresa,
} from '../../hooks/useEmpresas'
import { extractApiError } from '../../lib/extractApiError'
import styles from '../_shared/CrudPage.module.css'

const PAPEIS_VALIDOS: PapelEmpresa[] = ['CLIENTE', 'PLANEJADOR', 'EXECUTOR', 'LABORATORIO']

export default function EmpresaNovaPage() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const create = useEmpresaCreate()

  const papelDefault = (() => {
    const p = params.get('papel')
    return PAPEIS_VALIDOS.includes(p as PapelEmpresa) ? (p as PapelEmpresa) : undefined
  })()

  async function handleSubmit(data: EmpresaFormData) {
    try {
      const r = await create.mutateAsync(data)
      notifications.show({
        color: 'green',
        message: `Empresa ${r.data.razao_social} criada.`,
      })
      const papel = data.papeis[0] ?? papelDefault ?? 'CLIENTE'
      navigate(`/empresas/${r.data.id}?papel=${papel}`)
    } catch (err) {
      notifications.show({
        color: 'red',
        title: 'Falha ao criar empresa',
        message: extractApiError(err, 'Verifique os campos e tente novamente.'),
      })
    }
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <button
            className={styles.backBtn}
            type="button"
            onClick={() => navigate(-1)}
          >
            ← Voltar
          </button>
          <h1 className={styles.title}>Nova Empresa</h1>
        </div>
      </header>
      <EmpresaForm
        papelDefault={papelDefault}
        onSubmit={handleSubmit}
        isLoading={create.isPending}
        submitLabel="Criar Empresa"
      />
    </div>
  )
}
